import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { RiFlag2Line, RiMessage2Line, RiTimeLine, RiWallet3Line, RiDraftLine, RiEraserLine, RiImageLine, RiExternalLinkLine } from "react-icons/ri";
import OrderFact from "./OrderFact";
import OrderFinancialSummary from "./OrderFinancialSummary";
import OrderRiskBadge from "./OrderRiskBadge";
import OrderStatusBadge from "./OrderStatusBadge";
import { formatExactDate, formatPaymentSummary } from "./orderWorkspaceFormatters";
import styles from "./OrdersWorkspace.module.css";

export default function OrderWorkspaceHeader({ order, onSendSms, onMarkSpam, onRemoveSpam, onMarkDummy, onUnmarkDummy }) {
  const [showProof, setShowProof] = useState(false);
  if (!order) return null;
  const hasCustomerDetails = order.customer_email || order.customer_city || order.customer_zip_code || order.near_landmark;
  return (
    <>
    <header className={styles.orderHeader}>
      <div className={styles.orderIdentity}>
        <div className={styles.headingLine}>
          <h2>{order.order_number}</h2>
          {order.status && <OrderStatusBadge status={order.status} />}
          <OrderRiskBadge order={order} />
          {Number(order.is_dummy) === 1 && <span className={styles.dummyBadge}>Dummy</span>}
        </div>
        <p className={styles.customerName}>{order.customer_name || "Unknown customer"} {order.customer_phone ? `· ${order.customer_phone}` : ""}</p>
        <p className={styles.address}>{order.customer_address}</p>
        {hasCustomerDetails && (
          <div className={styles.customerDetails}>
            {order.customer_email && (
              <div className={styles.detailItem}>
                <span className={styles.detailLabel}>Email</span>
                <span className={styles.detailValue}>{order.customer_email}</span>
              </div>
            )}
            {order.customer_city && (
              <div className={styles.detailItem}>
                <span className={styles.detailLabel}>City</span>
                <span className={styles.detailValue}>{order.customer_city}</span>
              </div>
            )}
            {order.customer_zip_code && (
              <div className={styles.detailItem}>
                <span className={styles.detailLabel}>Postal code</span>
                <span className={styles.detailValue}>{order.customer_zip_code}</span>
              </div>
            )}
            {order.near_landmark && (
              <div className={styles.detailItem}>
                <span className={styles.detailLabel}>Landmark</span>
                <span className={styles.detailValue}>{order.near_landmark}</span>
              </div>
            )}
          </div>
        )}
        <div className={styles.orderFacts}>
          <OrderFact label="Placed" value={formatExactDate(order.created_at)} icon={RiTimeLine} />
          <OrderFact label="Updated" value={formatExactDate(order.updated_at)} icon={RiTimeLine} />
          <OrderFact label="Payment" value={formatPaymentSummary(order)} icon={RiWallet3Line} />
        </div>
        {order.trx_proof && (
          <button type="button" onClick={() => setShowProof(true)} className={styles.trxProofCard}>
            <img src={`${process.env.REACT_APP_URL_S3}/${order.trx_proof}`} alt="Payment Receipt" className={styles.trxProofThumb} />
            <span className={styles.trxProofOverlay}>
              <RiImageLine aria-hidden="true" />
              <span>View Receipt</span>
            </span>
          </button>
        )}
      </div>
      <OrderFinancialSummary order={order} totalOnly />
      <div className={styles.orderActions}>
        <Button className={`${styles.compactAction} ${styles.headerAction} ${styles.smsAction}`} variant="primary" onClick={() => onSendSms(order)}><RiMessage2Line aria-hidden="true" />Send SMS</Button>
        {Number(order.is_spam) === 0 && order.status !== "Completed" && <Button className={`${styles.compactAction} ${styles.headerAction} ${styles.spamAction}`} variant="outline-danger" onClick={() => onMarkSpam(order)}><RiFlag2Line aria-hidden="true" />Mark as Spam</Button>}
        {Number(order.is_spam) === 1 && <Button className={`${styles.compactAction} ${styles.headerAction} ${styles.removeSpamAction}`} variant="outline-warning" onClick={() => onRemoveSpam(order)}><RiFlag2Line aria-hidden="true" />Remove Spam</Button>}
        {Number(order.is_dummy) === 0 && <Button className={`${styles.compactAction} ${styles.headerAction} ${styles.dummyAction}`} variant="outline-secondary" onClick={() => onMarkDummy(order)}><RiDraftLine aria-hidden="true" />Mark as Dummy</Button>}
        {Number(order.is_dummy) === 1 && <Button className={`${styles.compactAction} ${styles.headerAction} ${styles.dummyAction}`} variant="outline-secondary" onClick={() => onUnmarkDummy(order)}><RiEraserLine aria-hidden="true" />Remove Dummy</Button>}
      </div>
    </header>
      <Modal show={showProof} onHide={() => setShowProof(false)} centered size="lg" className={styles.trxProofModal}>
        <Modal.Header closeButton className={styles.trxProofModalHeader}>
          <Modal.Title className={styles.trxProofModalTitle}>
            <RiImageLine aria-hidden="true" /> Payment Receipt
            <span className={styles.trxProofModalSubtitle}>{order.order_number}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.trxProofModalBody}>
          <img src={`${process.env.REACT_APP_URL_S3}/${order.trx_proof}`} alt="Payment Receipt" />
        </Modal.Body>
        <Modal.Footer className={styles.trxProofModalFooter}>
          <a href={`${process.env.REACT_APP_URL_S3}/${order.trx_proof}`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-sm">
            <RiExternalLinkLine aria-hidden="true" /> Open full size
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
}
